import { LayoutDashboard, LogOut, PackageCheck, Settings, Users } from "lucide-react";
import { NavLink } from "react-router-dom";
import { useAdminAuth } from "@/admin/auth/AdminAuthContext";

const navItems = [
  {
    to: "/admin/dashboard",
    label: "Dashboard",
    icon: LayoutDashboard,
  },
  {
    to: "/admin/dashboard",
    label: "Orders",
    icon: PackageCheck,
  },
  {
    to: "/admin/dashboard",
    label: "Partners",
    icon: Users,
  },
  {
    to: "/admin/dashboard",
    label: "Settings",
    icon: Settings,
  },
];

export function Sidebar({ onNavigate }) {
  const { session, logout } = useAdminAuth();

  return (
    <aside className="flex h-full flex-col rounded-[30px] border border-white/60 bg-[#0b43ff] text-white shadow-[0_32px_90px_rgba(0,51,255,0.28)]">
      <div className="border-b border-white/15 px-6 py-7">
        <p className="font-display text-xl font-extrabold tracking-tight">QuickDropGo</p>
        <p className="mt-2 text-sm text-white/72">Admin command center</p>
      </div>

      <nav className="flex-1 space-y-2 px-4 py-6">
        {navItems.map(({ to, label, icon: Icon }) => (
          <NavLink
            key={label}
            to={to}
            end={to === "/admin/dashboard"}
            onClick={onNavigate}
            className={({ isActive }) =>
              [
                "admin-sidebar-link flex items-center gap-3 rounded-2xl border border-transparent px-4 py-3 text-sm font-medium text-white/80 transition hover:border-white/15 hover:text-white",
                isActive ? "bg-white/12 text-white" : "",
              ].join(" ")
            }
          >
            {({ isActive }) => (
              <>
                <span
                  data-active={String(isActive)}
                  className="relative z-10 flex h-10 w-10 items-center justify-center rounded-2xl bg-white/12"
                >
                  <Icon className="h-5 w-5" />
                </span>
                <span className="relative z-10">{label}</span>
              </>
            )}
          </NavLink>
        ))}
      </nav>

      <div className="border-t border-white/15 px-4 py-5">
        <div className="mb-4 rounded-2xl bg-white/10 px-4 py-3">
          <p className="text-sm font-semibold">{session?.name}</p>
          <p className="mt-1 text-xs text-white/70">{session?.role}</p>
        </div>
        <button
          type="button"
          onClick={logout}
          className="flex w-full items-center justify-center gap-2 rounded-2xl border border-white/20 bg-white/10 px-4 py-3 text-sm font-semibold text-white transition hover:bg-white/18"
        >
          <LogOut className="h-4 w-4" />
          Logout
        </button>
      </div>
    </aside>
  );
}